<div class="ag-grid-tool-panel-wrapper">
    @if (gridReady && showConfigureLayout) {
        <div class="ag-grid-tool-panel" [hidden]="!isExpanded">
            @if (gridId) {
                <ag-grid-layout-specification [gridId]="gridId"
                                              [companyId]="companyId"
                                              [gridOptions]="gridOptions"
                                              [gridApi]="gridApi"
                                              [defaultColorizeHeaders]="defaultColorizeHeaders"
                                              [displayedColumnsChanged$]="displayedColumnsChanged$"
                                              (loadComplete)="specificationLoadComplete()"
                                              (specificationChanged)="specificationChanged($event)">
                </ag-grid-layout-specification>
            }
            <ag-grid-tool-panel-columns [gridOptions]="gridOptions"
                                        [gridApi]="gridApi"
                                        [specification]="specification"
                                        [gridId]="gridId"
                                        [defaultColorizeHeaders]="defaultColorizeHeaders"
                                        [displayedColumnsChanged$]="displayedColumnsChanged$">
            </ag-grid-tool-panel-columns>
        </div>
    }
    <div class="ag-grid-tool-panel-toggle ws-flex-container-vertical ws-flex-none">
        <div class="action-button-wrapper"
             helpTooltip
             [helpContentId]="configureLayoutHelpContentId"
             position="left">
            @if (showConfigureLayout) {
                <button
                    class="btn btn-xs btn-link"
                    [ngClass]="{'active': isExpanded }"
                    [disabled]="!gridReady"
                    (click)="onExpandClick()">
                    <div class="button-content">
                        <i class="fa fa-wrench"></i>
                    </div>
                </button>
            }
        </div>
        @if (showFilter) {
            <div class="action-button-wrapper"
                 helpTooltip
                 [helpContentId]="filtersHelpContentId"
                 position="left">
                <button class="btn btn-xs btn-link"
                        [ngClass]="{'active': isFilterVisible }"
                        [disabled]="!gridReady"
                        (click)="onFilterClick()">
                    <div class="button-content">
                        <i class="fa fa-filter"></i>
                    </div>
                </button>
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="ag-grid-tool-panel.clearFiltersHelpContentId"
                 position="left">
                <button class="btn btn-xs btn-link"
                        [disabled]="(!isFiltered) || (!gridReady)"
                        (click)="onClearFiltersClick()">
                    <div class="button-content">
                        <i class="fa fa-undo"></i>
                    </div>
                </button>
            </div>
        }
        <div class="action-button-wrapper"
             clickOutside
             (clickOutside)="hideFileFormatSelection()">
            <div helpTooltip
                 [helpContentId]="exportHelpContentId"
                 [position]="((!disableExport && exportOptions && exportOptions.showFileFormatSelection) ? 'top' : 'left')">
                @if (showExport) {
                    <button
                        class="btn btn-xs btn-link"
                        (click)="onExportClick()"
                        [disabled]="disableExport || !gridReady">
                        <div class="button-content">
                            <i class="fa" [ngClass]="exportIcon"></i>
                        </div>
                    </button>
                }
            </div>
            <div class="action-submenu" [class.open]="showFileFormatSelection">
                <ul>
                    @if (showFileFormat(fileFormats.excel)) {
                        <li (click)="onExportOptionSelected(fileFormats.excel)"
                            helpTooltip
                            helpContentId="ag-grid-tool-panel.export-excel"
                            position="left"
                        >Excel
                        </li>
                    }
                    @if (showFileFormat(fileFormats.tabDelimited)) {
                        <li (click)="onExportOptionSelected(fileFormats.tabDelimited)"
                            helpTooltip
                            helpContentId="ag-grid-tool-panel.export-tab-delimited"
                            position="left"
                        >Tab Delimited
                        </li>
                    }
                    @if (showFileFormat(fileFormats.pdf)) {
                        <li (click)="onExportOptionSelected(fileFormats.pdf)"
                            helpTooltip
                            helpContentId="ag-grid-tool-panel.export-pdf"
                            position="left"
                        >PDF
                        </li>
                    }
                    @for (t of exportOptions?.customExportFileFormats; track t) {
                        <li
                            (click)="!t.isDisabled() && onCustomExportOptionSelected(t.value)"
                            position="left"
                            [ngClass]="{'disabled': t.isDisabled()}"
                            [title]="t.isDisabled() ? (t.disabledTooltip || '') : ''">{{ t.name }}
                        </li>
                    }
                </ul>
            </div>
        </div>
        <div class="action-button-wrapper"
             helpTooltip
             helpContentId="ag-grid-tool-panel.size-to-fit"
             position="left">
            @if (showResizeColumns) {
                <button
                    class="btn btn-xs btn-link"
                    [disabled]="!gridReady"
                    (click)="sizeToFit()">
                    <div class="button-content">
                        <i class="fa fa-arrows-h"></i>
                    </div>
                </button>
            }
        </div>
        <div class="action-button-wrapper"
             helpTooltip
             helpContentId="ag-grid-tool-panel.size-to-content"
             position="left">
            @if (showResizeColumns) {
                <button
                    class="btn btn-xs btn-link"
                    [disabled]="!gridReady"
                    (click)="sizeToContent()">
                    <div class="button-content">
                        <i class="fa fa-text-width"></i>
                    </div>
                </button>
            }
        </div>
        <div class="action-button-wrapper"
             helpTooltip
             [helpContentId]="bulkUpdateButtonHelpId"
             position="left">
            @if (showBulkUpdate && showBulkUpdateLoading) {
                <div class="ace-btn btn-xs">
                    <div class="button-content">
                        <ws-ace-loader [inline]="true"></ws-ace-loader>
                    </div>
                </div>
            }
            @if (showBulkUpdate && !showBulkUpdateLoading) {
                <button
                    class="btn btn-xs btn-link"
                    [disabled]="!gridReady || disableBulkUpdate"
                    (click)="onBulkUpdateClick()">
                    <div class="button-content">
                        <i class="fa fa-edit"></i>
                    </div>
                </button>
            }
        </div>
        <div class="action-button-wrapper"
             helpTooltip
             helpContentId="ag-grid-tool-panel.bulk-delete"
             position="left">
            @if (showBulkDelete) {
                <button
                    class="btn btn-xs btn-link"
                    [disabled]="!gridReady"
                    (click)="onBulkDeleteClick()">
                    <div class="button-content">
                        <i class="fa fa-trash"></i>
                    </div>
                </button>
            }
        </div>
        @if (additionalActions && additionalActions.length) {
            <div
                class="action-button-wrapper"
                clickOutside
                (clickOutside)="hideAdditionalActions()">
                <div helpTooltip
                     helpContentId="ag-grid-tool-panel.additional-actions"
                     position="top">
                    <button class="btn btn-xs btn-link"
                            [ngClass]="additionalActionsVisible ? 'highlight' : 'd-none'"
                            (click)="onAdditionalActionClick()">
                        <div class="button-content">
                            <i class="fa fa-tasks"></i>
                        </div>
                    </button>
                </div>
                <div class="action-submenu" [class.open]="showAdditionalActions">
                    <ul>
                        @for (action of additionalActions; track action) {
                            <li
                                (click)="onAdditionalActionSelected(action)"
                                [class.disabled]="action.disabled()"
                                helpTooltip
                                [helpContentId]="action.helpContentId"
                                position="left">{{ action.name }}
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
        @for (button of additionalButtons; track button) {
            <div class="action-button-wrapper"
                 helpTooltip
                 [tooltipText]="button.getTooltipText()"
                 position="left"
            >
                @if (!button.isAsync) {
                    <button class="btn btn-xs btn-link"
                            [disabled]="!gridReady || button.disabled()"
                            (click)="button.onClickCallback()">
                        <div class="button-content">
                            <i class="fa {{button.icon}}"></i>
                        </div>
                    </button>
                }
                @if (button.isAsync) {
                    <button class="btn btn-xs btn-link"
                            [disabled]="!gridReady || button.disabled()"
                            (click)="button.onClickCallback()">
                        <div class="button-content">
                            @if (button.isLoading()) {
                                <ws-ace-loader [inline]="true"></ws-ace-loader>
                            } @else {
                                <i class="fa {{button.icon}}"></i>
                            }
                        </div>
                    </button>
                    <div class="action-submenu"
                         [class.open]="button.isMenuOpen"
                         clickOutside
                         (onClickOutside)="button.isMenuOpen = false;">
                        <ul>
                            @for (action of button.menuItems(); track action) {
                                <li
                                    (click)="button.isMenuOpen = false; action.onClick();">
                                    {{ action.name }}
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        }
    </div>
</div>
